import { useSelector } from 'react-redux';
import useActiveSite from './useActiveSite';
import { hasActiveFeatureFlag } from '../helpers/fetureFlagsHelper';
import useActiveUser from './useActiveUser';

const useHasActiveFeatureFlag = (flagName) => {
  const activeSite = useActiveSite();
  const sites = useSelector(state => state.entities.sites.byId);
  // get site info from sites entites in case the app state is not updated due to rehydration
  const currentSite = Object.values(sites).find((s) => s?.id === activeSite?.id);
  const activeUser = useActiveUser();
  const featureFlags = useSelector((state) => state.entities.featureFlags);
  const featureFlagsList = Object.values(featureFlags.byId);

  if (!activeUser) {
    return false;
  }

  if (currentSite) {
    return hasActiveFeatureFlag(flagName, currentSite, featureFlagsList);
  }

  return hasActiveFeatureFlag(flagName, activeSite, featureFlagsList);
};

export default useHasActiveFeatureFlag;
